package games.polyclub.website.frontend.store.pages.skyfactory

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.p
import games.polyclub.frontend.lib.react.simplified.tags.strong
import react.Props

val SkyFactoryHowToPlay = SFC<Props> { _ ->
    p {
        +"Para jogar você precisa instalar o modpack, e ter posse de um Passe de Acesso."
    }
    p {
        +"Veja a aba \"Como Instalar\" e a aba \"Passe de Acesso\" para obter informações."
    }
    p {
        +"Com o modpack aberto, clique em "
        strong {
            +"Multijogador"
        }
        +" e adicione um novo servidor com o nome "
        strong {
            +"GameMods: SkyFactory 4"
        }
        +" e endereço "
        strong {
            +"skyfactory.gamemods.com.br"
        }
        +"."
        p {
            +"Em seguida entre no servidor para jogar."
        }
    }
}
